export default __webpack_public_path__ + "static/interval-films-app-85c0d187def025906c59bb4427f4704a.png";